// extracted by mini-css-extract-plugin
export default {"root":"MainContainer_root__I9k5l","hasGradient":"MainContainer_hasGradient__sP2pv"};